import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../css/StudentAssignmentLockedMessage.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import { dateFormat } from '../utils/dateFormat';
import { getTimezoneAbbreviation } from '../utils/dateTimezone';

const StudentAssignmentLockedMessage = observer((props) => {
  const { assignment, lockedMessageKey, t } = props;

  const { userManager } = useContext(MobXProviderContext);

  if (!assignment || !lockedMessageKey) {
    return null;
  }

  if (lockedMessageKey === 'lockedByDate') {
    const timezoneAbbreviation = getTimezoneAbbreviation(
      assignment.timezoneStartAsDate || assignment.timezoneStartDate,
      userManager.user?.timezone
    );
    const startTimeLabelValue = [assignment.timezoneStartTime, timezoneAbbreviation]
      .filter((part) => !!part).join(' ');
    return (
      <div className='StudentAssignmentLockedMessage'>
        <div>
          <strong>{t('startDateLabel')}</strong>
          {dateFormat(assignment.timezoneStartAsDate || assignment.timezoneStartDate)}
        </div>
        <div>
          <strong>{t('startTimeLabel')}</strong>
          {startTimeLabelValue}
        </div>
      </div>
    );
  }

  return (
    <div className='StudentAssignmentLockedMessage'>
      <strong>{t(lockedMessageKey)}</strong>
    </div>
  );
});
export default StudentAssignmentLockedMessage;

SatCoreRegister('StudentAssignmentLockedMessage', StudentAssignmentLockedMessage);
